(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
      const wrapper = this.header.querySelector('.lt-header-wrapper');
      if (wrapper && typeof wrapper.ltMegaClose === 'function') wrapper.ltMegaClose();
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // LAURENTIDE: one shared mega panel under every top-level nav item.
  (function () {
    var wrapper = document.querySelector('.lt-header-wrapper');
    if (!wrapper) return;
    var panel = wrapper.querySelector('.lt-mega');
    var triggers = wrapper.querySelectorAll('[data-lt-mega-trigger]');
    if (!panel || !triggers.length) return;

    var desktop = window.matchMedia('(min-width: 990px)');
    var openTimer = null;
    var closeTimer = null;
    var isOpen = false;

    function setExpanded(value) {
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', value ? 'true' : 'false');
      });
    }

    function open() {
      window.clearTimeout(closeTimer);
      if (isOpen || !desktop.matches) return;
      isOpen = true;
      wrapper.classList.add('lt-mega-open');
      panel.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      setExpanded(true);
    }

    function close() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      if (!isOpen) return;
      isOpen = false;
      wrapper.classList.remove('lt-mega-open');
      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      setExpanded(false);
    }

    function scheduleOpen() {
      window.clearTimeout(closeTimer);
      window.clearTimeout(openTimer);
      openTimer = window.setTimeout(open, 80);
    }

    function scheduleClose() {
      window.clearTimeout(openTimer);
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(close, 120);
    }

    // Hover: opens after ~80ms over a nav item, closes when leaving header + panel.
    triggers.forEach(function (t) {
      t.addEventListener('mouseenter', scheduleOpen);
      t.addEventListener('focus', function () {
        if (desktop.matches) open();
      });
    });
    panel.addEventListener('mouseenter', function () {
      window.clearTimeout(closeTimer);
    });
    wrapper.addEventListener('mouseleave', scheduleClose);

    // Keyboard: close when focus leaves the header entirely, or on Escape.
    wrapper.addEventListener('focusout', function (event) {
      if (!event.relatedTarget || !wrapper.contains(event.relatedTarget)) close();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen) {
        close();
        if (document.activeElement && panel.contains(document.activeElement)) triggers[0].focus();
      }
    });
    desktop.addEventListener('change', function (e) {
      if (!e.matches) close();
    });

    // Let the sticky header (and anything else) close the panel via header-menu-like API.
    wrapper.ltMegaClose = close;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timer-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick(el) {
      var end = Date.parse(el.getAttribute('data-lt-countdown').replace(' ', 'T'));
      if (isNaN(end)) return;
      var diff = Math.max(0, end - Date.now());
      if (diff === 0) {
        var txt = el.getAttribute('data-expired-text');
        if (txt) el.textContent = txt;
        return;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600); s -= h * 3600;
      var m = Math.floor(s / 60); s -= m * 60;
      var map = { d: d, h: h, m: m, s: s };
      el.querySelectorAll('[data-lt-cd]').forEach(function (n) {
        n.textContent = pad(map[n.getAttribute('data-lt-cd')]);
      });
      window.setTimeout(function () { tick(el); }, 1000);
    }
    document.querySelectorAll('[data-lt-countdown]').forEach(tick);
  })();

  } catch(e) { console.error(e); }
})();
})();
